import { render, staticRenderFns } from "./csv-uploader.vue?vue&type=template&id=132b51fc&scoped=true"
import script from "./csv-uploader.vue?vue&type=script&lang=ts"
export * from "./csv-uploader.vue?vue&type=script&lang=ts"
import style0 from "./csv-uploader.vue?vue&type=style&index=0&id=132b51fc&prod&lang=scss"
import style1 from "./csv-uploader.vue?vue&type=style&index=1&id=132b51fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132b51fc",
  null
  
)

export default component.exports